<template>
  <!--<div class="app-container">
    <el-form ref="form" :model="form" label-width="120px">
      <el-form-item label="模板类型">
        <el-input v-model="form.name" />
      </el-form-item>
      <el-form-item label="版本号">
        <el-select v-model="form.region" placeholder="please select your zone">
          <el-option label="Zone one" value="shanghai" />
          <el-option label="Zone two" value="beijing" />
        </el-select>
      </el-form-item>
      <el-form-item label="模板类型">
        <el-col :span="11">
          <el-date-picker v-model="form.date1" type="date" placeholder="Pick a date" style="width: 100%;" />
        </el-col>
        <el-col :span="2" class="line">-</el-col>
        <el-col :span="11">
          <el-time-picker v-model="form.date2" type="fixed-time" placeholder="Pick a time" style="width: 100%;" />
        </el-col>
      </el-form-item>
      <el-form-item label="更新说明">
        <el-switch v-model="form.delivery" />
      </el-form-item>
      <el-form-item label="参数">
        <el-checkbox-group v-model="form.type">
          <el-checkbox label="Online activities" name="type" />
          <el-checkbox label="Promotion activities" name="type" />
          <el-checkbox label="Offline activities" name="type" />
          <el-checkbox label="Simple brand exposure" name="type" />
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="来源">
        <el-radio-group v-model="form.resource">
          <el-radio label="Sponsor" />
          <el-radio label="Venue" />
        </el-radio-group>
      </el-form-item>
      <el-form-item label="活跃">
        <el-input v-model="form.desc" type="textarea" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">创建</el-button>
        <el-button @click="onCancel">取消</el-button>
      </el-form-item>
    </el-form>
  </div>-->
  <div class="app-container">
    <el-form :model="submitData" ref="submitData" label-width="120px">
      <p title="点击展开/收起列" class="part-title cursor" @click="baseState = !baseState">基础信息 <i class="el-icon-arrow-down ml8 color-108cee" :class="{'el-icon-arrow-up': baseState}" />
        <span v-if="baseState" class="color-108cee font-size-12 ml4">收起</span>
        <span v-if="!baseState" class="color-108cee font-size-12 ml4">展开</span>
      </p>
      <div v-if="baseState" class="show-content">
<!--        <el-form-item label="模板类型">-->
<!--          <el-col :span="6">-->
<!--            <el-radio v-model="form.region" label="1" class="mr20">备选项</el-radio>-->
<!--            <el-radio v-model="form.region" label="2">备选项</el-radio>-->
<!--          </el-col>-->
<!--        </el-form-item>-->
        <el-form-item label="模板名称" prop="name" :rules= "[{ required: true, message: '请输入备注信息', trigger: true }]">
          <el-col :span="6">
            <el-input v-model="submitData.name" placeholder="请输入内容" />
          </el-col>

        </el-form-item>
        <el-form-item label="版本号" prop="version" :rules= "[{ required: true, message: '请输入备注信息', trigger: true }]">
          <el-col :span="6">
            <el-input v-model="submitData.version" placeholder="请输入内容" />
          </el-col>
        </el-form-item>
        <el-form-item label="更新说明" prop="remark" :rules= "[{ required: true, message: '请输入备注信息', trigger: true }]">
          <el-col :span="16">
            <el-input v-model="submitData.remark" type="textarea" />
          </el-col>
        </el-form-item>
      </div>

      <p title="点击展开/收起列" class="part-title cursor" @click="param = !param">参数 <i class="el-icon-arrow-down ml8 color-108cee" :class="{'el-icon-arrow-up': param}" />
        <span v-if="param" class="color-108cee font-size-12 ml4">收起</span>
        <span v-if="!param" class="color-108cee font-size-12 ml4">展开</span>
      </p>
      <div v-if="param" class="show-content">
        <el-form-item label="参数">
          <div>
            <div class="param-content">
              <div v-for="(item,index) in submitData.parameters" :key="index" class="flex mb10">
                <div class="param-item mr10">
                  <label class="mr8">显示名:</label>
                  <el-input v-model="item.xianshiName" class="w140" placeholder="请输入内容" />
                </div>
                <div class="param-item mr10">
                  <label class="mr8">参数名:</label>
                  <el-input v-model="item.paramName" class="w140" placeholder="请输入内容" />
                </div>
                <div class="param-item">
                  <label class="mr8">备注:</label>
                  <el-input v-model="item.remark" class="w140" placeholder="请输入内容" />
                </div>
                <div class="operation-btn">
                  <i class="el-icon-plus mr8" @click="addParam()" />
                  <i v-if="submitData.parameters.length>1" class="el-icon-close" @click="removeParam(item,index)" />
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
      </div>
      <p title="点击展开/收起列" class="part-title cursor" @click="JSCode = !JSCode">JS代码 <i class="el-icon-arrow-down ml8 color-108cee" :class="{'el-icon-arrow-up': JSCode}" />
        <span v-if="JSCode" class="color-108cee font-size-12 ml4">收起</span>
        <span v-if="!JSCode" class="color-108cee font-size-12 ml4">展开</span>
      </p>
      <div v-if="JSCode" class="show-content">
        <el-form-item label="JS代码">
         <!-- <el-col :span="23">
            <el-input v-model="submitData.code" class="js-css" type="textarea" />
          </el-col>-->
          <textarea ref="mycode" class="codesql" v-model="submitData.code" style="height:200px;width:600px;"></textarea>
        </el-form-item>
      </div>
    <!--  <div>
        <textarea ref="mycode" class="codesql" v-model="submitData.code" style="height:200px;width:600px;"></textarea>
      </div>-->
    </el-form>
    <div class="submitBtn">
      <el-button class="mr8" @click="onCancel">取消</el-button>
      <el-button type="primary" class="mr8" @click="onSubmit('submitData')">预览</el-button>
      <el-button type="primary" @click="onSubmit('submitData')">发布</el-button>
    </div>
  </div>
</template>

<script>

// import 'codemirror/theme/ambiance.css'
import 'codemirror/theme/3024-night.css'
import 'codemirror/lib/codemirror.css'
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/addon/selection/active-line'

const CodeMirror = require('codemirror/lib/codemirror')
require('codemirror/addon/edit/matchbrackets')
require('codemirror/addon/selection/active-line')
require('codemirror/mode/sql/sql')
require('codemirror/addon/hint/show-hint')
require('codemirror/addon/hint/sql-hint')
import { addTemplate } from '../../api/table'

export default {
  data() {
    return {
      submitData: {
        name: '',
        version: '',
        remark: '',
        code: '',
        parameters: [{ xianshiName: '', paramName: '', remark: '' }]
      },
      rules: {
        name: [
          { required: true, message: '请输入模板名称', trigger: true }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        version: [
          { required: true, message: '请选择版本', trigger: 'change' }
        ],
        remark: [
          { required: true, message: '请输入备注信息', trigger: true }
        ]
      },
      baseState: true,
      param: true,
      JSCode: true,
      msg: '',
      myCm: '',
      placeholder: '每行',
      cmOptions: {
        value: '',
        mode: 'text/html',
        theme: 'foo bar',
        smartIndent: true,
        tabSize: 4,
        readOnly: false,
        showCursorWhenSelecting: true,
        lineNumbers: true,
        firstLineNumber: 1
      },
      editor: null
      // code: '//按Ctrl键进行代码提示'
    }
  },
  mounted() {
    const mime = 'text/x-mariadb'
    this.editor = CodeMirror.fromTextArea(this.$refs.mycode, {
      mode: mime, // 选择对应代码编辑器的语言，我这边选的是数据库，根据个人情况自行设置即可
      indentWithTabs: true,
      indentUnit: 4, // 缩进单位，默认2
      tabSize: 4, // Tab缩进，默认4
      smartIndent: true,
      lineNumbers: true,
      matchBrackets: true,
      // theme: 'monokai', // 编辑器主题
      // theme: theme,
      // autofocus: true,
      extraKeys: { 'Ctrl': 'autocomplete' }, // 自定义快捷键
      hintOptions: {// 自定义提示选项
        tables: {
          users: ['name', 'score', 'birthDate'],
          countries: ['name', 'population', 'size']
        }
      },
      theme: '3024-night'
    })
    // 代码自动提示功能，记住使用cursorActivity事件不要使用change事件，这是一个坑，那样页面直接会卡死
    this.editor.on('cursorActivity', function() {
      // this.editor.showHint()
    })
  },
  methods: {
    onSubmit(formName) {
      const jsCode = this.editor.getValue()
      this.submitData.code = jsCode
      /*   this.$refs.formName.validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })*/
      addTemplate(this.submitData).then(results => {
        if (results.code === 0) {
          this.$message('submit!')
        } else {
          this.$message.error(results.msg)
        }
      })
      // this.$router.back(-1)
    },
    onCancel() {
      this.$message({
        message: 'cancel!',
        type: 'warning'
      })
      this.$router.back(-1)
    },
    addParam() {
      this.submitData.parameters.push({ xianshiName: '', paramName: '', remark: '' })
    },
    removeParam(data, index) {
      this.paramArray.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
  .codesql {
    font-size: 11pt;
    font-family: Consolas, Menlo, Monaco, Lucida Console, Liberation Mono, DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier New, monospace, serif;
  }
  .app-container{
    height: calc(100vh - 90px);
    overflow: hidden;
    overflow-y: auto;
  }
  .el-form{
    height: calc(100vh - 90px - 70px);
    overflow-y: auto;
    /*padding-bottom: 100px;*/
  }
  .part-title{
    /*display: inline-block;*/
    position: relative;
    padding-left: 20px;
    font-size: 14px;
    margin-left: 10px;
  }
  .part-title::before{
    position: absolute;
    content: '';
    width: 2px;
    height: 12px;
    background: #108cee;
    left: 11px;
    top: 2px;
  }

  .show-content{
    margin-bottom: 35px;
    margin-top: 20px;
  }
.line{
  text-align: center;
}
.el-form-item{
  margin-bottom: 20px;
}
.param-content{
  /*display: flex;*/
  /*border: 1px solid #DCDFE6;*/
  /*background: #fbfbfb;*/
  /*padding: 8px 10px;*/
  .param-item{
    display: flex;
    label{
      line-height: 25px;
    }
  }
  .operation-btn{
    color: #108cee;
    font-size: 14px;
    line-height: 24px;
    margin-left: 15px;
    i{
      cursor: pointer;
    }
  }
  label{
    color: #606266;
    font-size: 12px;
    font-weight: 500;
  }

}
  .app-container {
    position: relative;
  }
  .submitBtn{
    position: absolute;
    bottom: 0px;
    margin: 0;
    margin-bottom: 0px;
    left: 0;
    width: 100%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    /*border-top: 1px solid #EBEEF5;*/
    box-shadow: 0px 4px 10px #ccc;
    .el-button {
      padding: 0 16px;
      font-size: 14px;
      height: 30px !important;
    }
  }
</style>

